var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container", title: "新增地址" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c(
            "van-popup",
            {
              staticClass: "creatRight",
              attrs: { position: "right", overlay: false },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c(
                "div",
                { staticClass: "creatAddress" },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c("van-field", {
                        attrs: {
                          required: "",
                          label: "收货人：",
                          placeholder: "请输入收货人",
                          "error-message": _vm.consigneeError
                        },
                        on: { focus: _vm.focusInput },
                        model: {
                          value: _vm.Consignee,
                          callback: function($$v) {
                            _vm.Consignee = $$v
                          },
                          expression: "Consignee"
                        }
                      }),
                      _vm._v(" "),
                      _c("van-field", {
                        attrs: {
                          required: "",
                          label: "联系电话：",
                          placeholder: "请输入联系电话",
                          "error-message": _vm.phoneError
                        },
                        on: { focus: _vm.focusInput },
                        model: {
                          value: _vm.mobileNumber,
                          callback: function($$v) {
                            _vm.mobileNumber = $$v
                          },
                          expression: "mobileNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "van-cell-group",
                    { staticClass: "mt12" },
                    [
                      _c("van-cell", {
                        attrs: {
                          required: "",
                          title: "所在地区：",
                          "is-link": "",
                          value: _vm.addressValue
                        },
                        on: { click: _vm.chooseAddress }
                      }),
                      _vm._v(" "),
                      _c("van-field", {
                        attrs: {
                          required: "",
                          label: "详细地址：",
                          maxlength: 50,
                          type: "textarea",
                          placeholder: "请输入详细地址",
                          rows: "1",
                          autosize: "",
                          "error-message": _vm.addressError
                        },
                        on: { focus: _vm.focusInput },
                        model: {
                          value: _vm.DetailedAddress,
                          callback: function($$v) {
                            _vm.DetailedAddress = $$v
                          },
                          expression: "DetailedAddress"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-cell",
                        {
                          attrs: {
                            title: "设为默认地址",
                            label: "注：每次下单将默认该地址为收货地址"
                          }
                        },
                        [
                          _c("van-switch", {
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btnStyle" },
                [
                  _vm.isEditShow
                    ? _c(
                        "van-button",
                        {
                          attrs: {
                            round: "",
                            type: "danger",
                            loading: _vm.saveLoading
                          },
                          on: { click: _vm.saveAddress }
                        },
                        [_vm._v("添加")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditShow
                    ? _c(
                        "van-button",
                        {
                          attrs: { round: "", type: "danger" },
                          on: { click: _vm.updateSaveAddress }
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    {
                      staticClass: "cancelBtn",
                      attrs: { round: "" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "van-popup",
            {
              attrs: { position: "bottom", overlay: false },
              model: {
                value: _vm.addressShow,
                callback: function($$v) {
                  _vm.addressShow = $$v
                },
                expression: "addressShow"
              }
            },
            [
              _c("van-area", {
                attrs: { "area-list": _vm.areaList, value: "110101" },
                on: { cancel: _vm.cancelArea, confirm: _vm.confirmArea }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }